import React from 'react';
import { cn } from '@/lib/utils';
import { workersInGroup, workersInRegion, wArr, readiness } from '../../engine/data';
import { rdyTone } from '../../engine/scores';
import { useDash } from '../../state';
import { Dot, toneBg } from '../../ui';

/** Scope-aware worker chips (same group / region / everyone), highest FED first. */
export const WorkerPicker: React.FC = () => {
  const { activeGroup, activeRegion, activeWorker, drillWorker } = useDash();
  const pool =
    activeGroup !== null ? workersInGroup(activeGroup) : activeRegion ? workersInRegion(activeRegion) : wArr();
  const sorted = [...pool].sort((a, b) => b.fed - a.fed);

  return (
    <div className='mb-4 flex flex-wrap items-center gap-2 border-b border-border pb-3'>
      <span className='mr-1 text-[11px] font-semibold uppercase tracking-wider text-muted-foreground'>Individual</span>
      {sorted.map((p) => {
        const active = p.init === activeWorker;
        return (
          <button
            key={p.init}
            type='button'
            onClick={() => drillWorker(p.init)}
            className={cn(
              'flex items-center gap-1.5 rounded-md border px-2.5 py-1 text-xs font-medium transition-colors',
              active
                ? 'border-success/30 bg-success/10 text-success'
                : 'border-border bg-muted text-muted-foreground hover:bg-accent hover:text-foreground',
            )}
          >
            <Dot className={cn('h-1.5 w-1.5', toneBg[rdyTone(readiness(p))])} />
            {p.init} {p.name.split(' ')[0]}
          </button>
        );
      })}
    </div>
  );
};
